/** Cliente HTTP de la Revisión de consumos: contratos marcados por
 *  patrones de consumo (fuga probable, medidor inactivo). Espejo del
 *  schema `ConsumosAnomalosResponse` del backend. */
import { apiRequest } from "../../lib/api";

export interface PuntoConsumo {
  anio: number;
  mes: number;
  consumo_m3: number;
}

export interface ConsumoAnomalo {
  contrato_id: number;
  socio_id: number;
  socio_nombre: string;
  socio_rut: string | null;
  numero_socio: number | null;
  arranque_codigo: string | null;
  arranque_direccion: string | null;
  sector_nombre: string | null;
  /** Medidor instalado hoy en el arranque (para abrir la OT de revisión). */
  medidor_id: number | null;
  medidor_numero_serie: string | null;
  periodo_anio: number;
  periodo_mes: number;
  consumo_actual: number;
  promedio_previo: number | null;
  factor: number | null;
  meses_en_cero: number | null;
  /** "detenido" (ceros hasta hoy) | "intermitente" (volvió el consumo). */
  patron_cero: string | null;
  historial: PuntoConsumo[];
}

export interface ConsumosAnomalosResponse {
  generado_en: string;
  fugas: ConsumoAnomalo[];
  ceros: ConsumoAnomalo[];
}

export function listarConsumosAnomalos(): Promise<ConsumosAnomalosResponse> {
  return apiRequest<ConsumosAnomalosResponse>(
    "/api/v1/dashboard/consumos-anomalos",
  );
}
